<template>
    <div class="content">
        Contacts PAGE
    </div>



</template>
<script>
  export default {
    name: "Contacts"
  };
</script>
<style lang="scss">
</style>
